<div class="padding-botton-10" id="isChildDeceased">
      <ng-radio [item-list]="items.yesNoList" id="isChildDeceasedRadio"
           [(ng-model)]="input" 
           [(ng-error)]="error_isChildDeceased" (change)="onChange()">
      <h2 translate>{{'setup_2.questions.isChildDeceased'}}</h2>
      </ng-radio>
 </div>

 <div class="padding-top-5">
      <accordion header="setup_2.accordion1.header" outer-class="bottom-margin">
           <div class="padding-top-1em" translate>
                {{'setup_2.accordion1.text1'}}
           </div>
           <div class="padding-top-1em" [innerHTML]="'setup_2.accordion1.text2' | translate"></div>
           <div class="padding-top-1em">
                {{"setup_2.accordion1.text3" | translate}}
                <a routerLink="/{{ orgContactPath }}" href="#" title="{{'setup_2.org_contact_title' | translate}}">
                     {{"setup_2.org_contact" | translate}}</a>.
           </div>
      </accordion>
 </div>

 <div class="padding-top-5" [hidden]="stillBirth!='Y'">
      <accordion header="setup_2.accordion2.header">
           <span class="page-title">
                {{"setup_2.accordion2.text1" | translate}}
                <a routerLink="/{{ orgContactPath }}" href="#"
                     title="{{'setup_2.org_contact_title' | translate}}">{{
                     "setup_2.org_contact" | translate
                     }}</a>.
           </span>
      </accordion>
 </div>
 <div aria-live='polite'>
 <div [hidden]="!(input === 'Y')" class="padding-top-10">
      <information outer-style="width:100%">
           <ng-container *ngTemplateOutlet="additionalInformation"></ng-container>
      </information>
 </div>
 </div>
 
 <ng-template id="additionalInformation" #additionalInformation>
      <h3>
           {{'setup_2.additional_info.header' | translate}}
      </h3>
      <div>
           <div class="page-title" translate style="margin-bottom:1em">{{"setup_2.additional_info.text1"}}</div>
           <div class="page-title" [innerHTML]="'setup_2.additional_info.text2' | translate"></div>
           <ul>
                <li>
                     <span class="page-title" translate>
                          {{ "setup_2.additional_info.death_cert" }}
                     </span>
                </li>
                <li>
                     <span class="page-title" translate>
                          {{ "setup_2.additional_info.stmt_of_death" }}
                     </span>
                </li>
           </ul>
 
           <div class="page-title" [innerHTML]="'setup_2.additional_info.header_note' | translate">
           </div>
           <div class="page-title" [innerHTML]="'setup_2.additional_info.birth_cert' | translate">
           </div>
      </div>
 </ng-template>
 
